import Vue from 'vue'
import Router from 'vue-router'
import Axios from 'axios'
import md5 from 'js-md5'
import {
  Notify
} from 'vant'
import api from '@/api'
import routes from '@/router/routers'
import store from '@/store/index'
import config from '@/config/url'
import sensors from '@/utils/sensors'

Vue.use(Router)
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
const router = new Router({
  mode: 'history',
  routes,
})

let homepage = null

const SHOW_TABBARS = ['home', 'course', 'learning', 'saccount', 'personalCenter_new', 'goodsList']

const JUMP_PAGE = ['standard', 'standardDetail', 'initTrainingIdx']

// 判断ios手机
let u = navigator.userAgent
let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
let ua = window.navigator.userAgent.toLowerCase()
let notRemove = ['/examTaking', '/faceidentify', '/faceauthsuccess', '/faceauthfail', '/privacypolicy']

let isNewSaasConfig, isNewSaas
let isFirst = true //第一次获取配置标识

// 跳转首页
function jumpPage(next, homeIndex) {
  if (homeIndex && homeIndex.value) {
    next({
      path: homeIndex.value,
      replace: true
    })
  } else {
    next({
      path: '/home',
      replace: true
    })
  }
}
router.beforeEach(async (to, from, next) => {
  if (to.query.mpWx == '1') {
    localStorage.setItem("mpWx", 1);
    console.log('from.query.mpWx')
  }
  // 是否用户中心改造 
  if (isFirst && !isNewSaasConfig) {
    let frontendConfig = sessionStorage.getItem('frontendConfig') && JSON.parse(sessionStorage.getItem('frontendConfig')) || [];

    // console.error('router=frontendConfig==',sessionStorage.getItem('frontendConfig'))
    // await api.configuration.getConfigurationNew().then((res) => {
    isNewSaasConfig = frontendConfig.find((item) => item.key === 'isNewSaas')
    // console.log('first----------------------------', store.state.dynamic.frontendConfig, isNewSaasConfig)
    isFirst = false
    if (isNewSaasConfig) {
      if (isNewSaasConfig.value === 'true') {
        isNewSaas = true
        store.commit('setSaasFlag', true)
      }
    }
    // })
  }

  // 如果携带token自动处理后续登录逻辑
  if (to.query.token) {
    // 保证登录最新的账号
    store.commit('logout')
    localStorage.setItem('token', to.query.token)
    await afterLogin(to.query.isAutoRegister)
  }

  // 记录触发实名认证的页面
  if (to.name === 'idcard' || to.name === 'cepverification' || to.name === 'goodsList' || to.name === 'goodsDetail') {
    store.state.idcardBefore = from.fullPath
  }

  // 登录后跳转实名认证页面
  if (to.query.realName) {
    sessionStorage.setItem('realName', true)
  }

  if (!notRemove.includes(to.path)) {
    sessionStorage.removeItem('secondsExam')
    sessionStorage.removeItem('allowCommitDurationExam')
  }

  // 分销商id登录接口用
  if (to.query.distributionId) store.state.distributionId = to.query.distributionId
  if (!store.state.dynamic.frontendConfig.length || localStorage.getItem('theme') == null) {
    let res = await api.configuration.getConfigurationNew();
    store.commit('frontendConfig', res.data.frontendConfig);
    localStorage.setItem('theme', res.data.theme);
  }
  console.log(store.state.dynamic.frontendConfig, 'vuex存储的frontendConfig------------')
  if (!homepage) {
    // 首页配置
    homepage = store.state.dynamic.frontendConfig.find((item) => {
      if (item.key === 'homepage') {
        return true
      }
    })
    document.title = store.state.dynamic.pageTitle
    localStorage.setItem('pageTitle', store.state.dynamic.pageTitle)
    console.log(store.state.dynamic.pageTitle, 'vuex存储的pageTitle------------')
  }
  // if (homepage && to.path.replace('/', '') === homepage.value) {
  //     let is_track_single_page = localStorage.getItem('is_track_single_page')
  //     is_track_single_page == 'true' ? is_track_single_page = true : is_track_single_page = false
  //     !is_track_single_page && sensors.track('wdpageview')
  // }

  const token = localStorage.getItem('token')
  if (homepage && token) {
    if (localStorage.getItem('pageTitle')) {
      document.title = localStorage.getItem('pageTitle')
    }
  }

  //新版用户系统-定制注册页面跳转
  if (to.path === '/registered') {
    if (isNewSaas) {
      next('register_new')
    } else {
      next()
    }
  }

  //已经登陆仍然访问login时，直接去首页
  if (token && (to.path === '/login' || to.path === '/login_new')) {
    if (localStorage.getItem('theme') != 'renshefenguan') {
      if (homepage && homepage.value) {
        console.log(homepage.value, '模块化配置的首页-----------')
        next({
          path: homepage.value,
          replace: true
        })
      } else {
        next({
          path: '/home',
          replace: true
        })
      }
    } else {
      const WDuserInfo = localStorage.getItem("WDuserInfo") ? JSON.parse(localStorage.getItem("WDuserInfo")) : {};
      const {
        userUcode,
        idAuthStatus,
        faceAuthStatus
      } = WDuserInfo;
      if (!idAuthStatus || !faceAuthStatus) {
        next('/rensheMyProfile?type=auth')
        return;
      }
      if (store.state.rsDistribution.finishAuth) {
        jumpPage(next, homepage)
      } else {
        checkRensheDistributionAuth(next, userUcode, homepage)
      }
    }
  }

  if (to.meta && !to.meta.login) {
    console.log(to.path, 'to.path------------')
    if (to.path == '/') {
      if (homepage && homepage.value) {
        console.log(homepage.value, '模块化配置的首页-----------')
        next(homepage.value)
      } else {
        if (isNewSaas) {
          next('/login_new')
        } else {
          next('/login')
        }
      }
    } else {
      next()
    }
  } else {
    if (token) {
      /** 判断iOS默认浏览器登录状态 直播引导页跳转过去直接进登录页 iOS手机微信浏览器 */
      if (isiOS && ua.match(/MicroMessenger/i) != 'micromessenger' && to.name == 'liveSkip') {
        if (isNewSaas) {
          next('/login_new')
        } else {
          next('/login')
        }
      } else if (to.query.name === 'xuexi' || to.query.name === 'kaoshi') {
        next({
          name: 'home'
        })
      } else {
        //人社分管营销定制
        if (localStorage.getItem('theme') === 'renshefenguan' && !['rensheMyProfile', 'idcard', 'idcardconfirm', 'scan', 'finishExamAuth', 'authfail'].includes(to.name)) {
          const WDuserInfo = localStorage.getItem("WDuserInfo") ? JSON.parse(localStorage.getItem("WDuserInfo")) : {};
          const {
            userUcode,
            idAuthStatus,
            faceAuthStatus
          } = WDuserInfo;
          if (!idAuthStatus || !faceAuthStatus) {
            next('/rensheMyProfile?type=auth')
            return;
          }
          if (store.state.rsDistribution.finishAuth) {
            next();
          } else {
            checkRensheDistributionAuth(next, userUcode)
          }
        } else {
          next()
        }

      }
    } else {
      if (JUMP_PAGE.includes(to.name)) {
        next()
      } else {
        if (isNewSaas) {
          next('/login_new')
        } else {
          next('/login')
        }
      }
    }
  }
  if (SHOW_TABBARS.includes(to.name)) {
    store.commit('setTabbar', {
      show: true,
      active: to.name,
    })
  } else {
    store.commit('setTabbar', {
      show: false
    })
  }
})

router.afterEach(() => {
  window.scrollTo(0, 0)
})
// 登录后续逻辑
async function afterLogin(isAutoRegister) {
  console.log('执行了登录后续');
  const loginToCurrent = is_login_current_branch()
  let branchId, branchUcode
  if (loginToCurrent) { //是否登录到指定的机构
    branchId = localStorage.getItem('branchId')
    branchUcode = localStorage.getItem('branchUcode')
    if (!branchId || !branchUcode) {
      let res = await api.configuration.getConfigurationNew()
      branchId = res.data.branchId
      branchUcode = res.data.branchUcode
      localStorage.setItem('branchId', branchId)
    }
  }
  if (!localStorage.getItem('token').includes('ss_')) {
    // 获取机构信息
    return Axios({
      baseURL: config.API,
      url: '/usercenter/v1/account/findUserBranchList',
      headers: {
        token: localStorage.getItem('token')
      }
    }).then(res => {
      const branchRes = res.data
      if (branchRes.success) {
        if (branchRes.data && branchRes.data.length) {
          let currentBranch = branchRes.data[0]

          if (loginToCurrent) { //登录到指定机构
            currentBranch = branchRes.data.find((item) => {
              let branch = md5(branchId + item.token).toUpperCase()
              return item.branch === branch
            })
          }
          if (currentBranch) {
            localStorage.setItem('code', currentBranch.code)
            localStorage.setItem('organ', currentBranch.organ)
            localStorage.setItem('actor', currentBranch.actor)
            localStorage.setItem('branch', currentBranch.branch)
            currentBranch.channel && localStorage.setItem('channel', currentBranch.channel)
            // 获取用户信息
            getUserInfo()
            // 获取用户id
            findUserId()
          } else {
            if (isAutoRegister) {
              return accountJoinBranch(branchUcode)
            } else {
              Notify({
                type: 'danger',
                message: '暂未加入当前机构'
              })
            }
          }
        } else {
          if (isAutoRegister) {
            return accountJoinBranch(branchUcode)
          }
        }
      } else if (branchRes.code === 303) {
        if (isAutoRegister) {
          return accountJoinBranch(branchUcode)
        } else {
          Notify({
            message: branchRes.message,
            type: 'danger',
            duration: 2000
          })
        }
      } else {
        Notify({
          message: branchRes.message,
          type: 'danger',
          duration: 2000
        })
      }
    }).catch(error => {
      console.log(error, '出错了-------------------')
    })
  }

}

// 是否登录到指定机构
function is_login_current_branch() {
  let is_login_current_branch = store.state.dynamic.frontendConfig.find((item) => item.key === 'is_login_current_branch')
  if (is_login_current_branch) {
    if (is_login_current_branch.value === 'true') {
      return true
    }
  }
  return false
}

// 获取机构列表
async function getFindUserBranchList() {
  const loginToCurrent = is_login_current_branch()
  const branchId = localStorage.getItem('branchId')
  console.log(branchId, '登录到指定机构的id--------------------------')
  let branchRes = await api.account.getFindUserBranchList({})
  if (branchRes.data && branchRes.data.length) {
    let currentBranch = branchRes.data[0]
    console.log(loginToCurrent, '是否登录到指定机构配置项--------------------------')
    if (loginToCurrent) { //是否登录到指定机构
      currentBranch = branchRes.data.find((item) => {
        let branch = md5(branchId + item.token).toUpperCase()
        return item.branch === branch
      })
      console.log(currentBranch, '比对到的当前机构信息---------------------------')
    }
    if (currentBranch) {
      localStorage.setItem('code', currentBranch.code)
      localStorage.setItem('organ', currentBranch.organ)
      localStorage.setItem('actor', currentBranch.actor)
      localStorage.setItem('branch', currentBranch.branch)
      currentBranch.channel && localStorage.setItem('channel', currentBranch.channel)
    }
  } else {
    return
  }
  // 获取用户信息
  getUserInfo()
  // 获取用户id
  findUserId()
}

// 自动注册到跟机构/指定机构
async function accountJoinBranch(branchUcode) {
  const loginToCurrent = is_login_current_branch()
  let params = loginToCurrent ? {
    branchUcode
  } : null
  console.log(params, '自动注册到指定的机构的ucode-------------------')
  return api.usercenter.accountJoinBranch(params).then(res => {
    if (res.success) {
      return getFindUserBranchList()
    }
  })
}

// 获取用户信息
function getUserInfo() {
  api.usercenter.getAccountUserInfo({}).then((res) => {
    localStorage.setItem('WDuserInfo', JSON.stringify(res.data))
    store.commit('setUserInfo', res.data)
  })
}

// 查询用户id
function findUserId() {
  api.usercenter.findUser().then((res) => {
    if (res.code == 0) {
      let subUser = {
        id: res.data.id
      }
      localStorage.setItem('subUserInfo', JSON.stringify(subUser))
    }
  })
}

// 人社分管营销考试平台是否已完善资料
async function checkRensheDistributionAuth(next, userUcode, toPage) {
  const res2 = await api.rensheDistributionExam.findUserAnnexByParam({
    ucode: userUcode
  })
  if (res2.code == 0 && res2.success) {
    console.log("router-indexjs-api")
    //是否填写完资料
    const rensheDistributionIsAuth = res2.data && Array.isArray(res2.data) && res2.data.length > 0;
    store.commit('setRsDistribution', rensheDistributionIsAuth)
    if (rensheDistributionIsAuth) {
      // 如果是登录页面进入到首页
      if (toPage) {
        jumpPage(next, homepage)
      } else {
        next();
      }
    } else {
      next('/rensheMyProfile?type=auth')
      // Notify({
      //     type: 'danger',
      //     message: '请先完善个人资料',
      //     duration: 2500,
      //     onClose: () => {
      //         next('/rensheMyProfile')
      //     }
      // })
    }
  }
}

export default router